<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <spoil-control></spoil-control>
      <spoil-view></spoil-view>
    </v-layout>
  </v-container>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import SpoilControl from "@/components/spoils/spoilControl";
import SpoilView from "@/components/spoils/spoilView";

export default {
  data() {
    return {};
  },
  methods: {},
  computed: {},
  mounted() {},
  components: {
    SpoilControl,
    SpoilView
  }
};
</script>

<style scoped>
.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
        /* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
